<template>
  <div>
    <!-------------------------------------------TOOLBAR------------------------------------------->
    <toolbar @search-dialog="openSearchDialog" />
    <maintenance-banner class="ma-2" />
    <!---------------------------------------GENERAL DETAILS--------------------------------------->
    <stats v-if="$store.getters.role !== 'LekoBot'" />
    <!----------------------------------------USER HISTORY----------------------------------------->
    <div
      v-if="
        [
          'LekoAdmin',
          'SuperAdmin',
          'InstitutionAdmin',
          'LekoEmployee',
        ].includes($store.getters.role)
      "
    >
      <!--TOOLBAR-->
      <v-toolbar flat theme="dark" color="grey-darken-4" dense>
        <!-- Title -->
        <v-toolbar-title
          v-if="
            ($vuetify.display.xs && !userHistory) || $vuetify.display.mdAndUp
          "
          style="display: table !important"
          @click="userHistory = !userHistory"
        >
          {{ $t("home.user_history") }}
        </v-toolbar-title>

        <v-spacer />
        <v-btn text icon @click="userHistory = !userHistory">
          <v-icon v-if="userHistory"> mdi-chevron-up </v-icon>
          <v-icon v-else> mdi-chevron-down </v-icon>
        </v-btn>
      </v-toolbar>
      <v-card class="ma-2 pa-2">
        <div class="d-flex justify-center align-center">
          <!-- Desktop: horizontal checkbox bar -->
          <div v-if="userHistory && !$vuetify.display.xs" class="statusBar mr-2 ml-0 ml-sm-16">
            <div class="statusBarLabel">
              {{ $t("home.select_status") }}
            </div>
            <div
              class="statusBarItems"
              :class="{ statusBarItemsWrap: shouldWrapStatuses }"
            >
              <div
                v-for="status in availableStatusItems"
                :key="status.value"
                class="statusBarItem"
                role="button"
                tabindex="0"
                @click="toggleStatus(status.value)"
                @keydown.enter.prevent="toggleStatus(status.value)"
                @keydown.space.prevent="toggleStatus(status.value)"
              >
                <v-checkbox-btn
                  :model-value="selectedItems.includes(status.value)"
                  density="compact"
                  class="statusBarCheckbox"
                />
                <span class="statusBarText">{{ status.title }}</span>
              </div>
            </div>
          </div>

          <!-- Mobile: dropdown menu -->
          <v-menu v-if="userHistory && $vuetify.display.xs" :close-on-content-click="false">
            <template #activator="{ props }">
              <v-btn
                v-bind="props"
                variant="outlined"
                density="compact"
                color="grey-darken-3"
                append-icon="mdi-chevron-down"
                class="text-caption"
              >
                {{
                  selectedItems.length > 0
                    ? `${selectedItems.length} / ${availableStatusItems.length} ${$t("home.select_status")}`
                    : $t("home.select_status")
                }}
              </v-btn>
            </template>
            <v-list density="compact" min-width="200">
              <v-list-item
                v-for="status in availableStatusItems"
                :key="status.value"
                :title="status.title"
                @click="toggleStatus(status.value)"
              >
                <template #prepend>
                  <v-checkbox-btn
                    :model-value="selectedItems.includes(status.value)"
                    density="compact"
                    class="mr-1"
                  />
                </template>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-btn
            v-if="userHistory && $vuetify.display.smAndUp"
            :disabled="selectedItems.length < 1"
            text
            icon
            color="black"
            class="mr-2"
            @click="loadCharts"
          >
            <v-icon>mdi-orbit-variant</v-icon>
          </v-btn>
        </div>
      </v-card>
      <!--USER SELECTION (ADMIN & OWNER)-->
      <v-row
        v-if="
          userHistory &&
          ($store.getters.role === 'LekoAdmin' ||
            $store.getters.role === 'LekoEmployee' ||
            $store.getters.role === 'InstitutionAdmin' ||
            $store.getters.role === 'SuperAdmin')
        "
        class="mt-2 d-flex justify-center text-center"
      >
        <v-col class="pl-4 pr-2" cols="12" xs="12" sm="6" md="4">
          <v-select
            v-model="selectedUserRole"
            :items="filteredUserRoles"
            :label="$t('home.user_role')"
            :hint="$t('home.select_user_role')"
            variant="solo"
            text
            prepend-inner-icon="mdi-account-question-outline"
            item-title="title"
            item-value="value"
            persistent-hint
            color="red-darken-2"
          />
        </v-col>

        <v-col class="pl-4 pr-2" cols="12" xs="12" sm="6" md="4">
          <v-select
            v-model="selectedUser"
            :items="users"
            :hint="$t('home.select_user')"
            :loading="loading"
            variant="solo"
            item-title="name"
            item-value="_id"
            persistent-hint
            color="red-darken-2"
            prepend-inner-icon="mdi-account"
            clearable
            @click:prepend-inner="selectedUser = null"
          />
        </v-col>
      </v-row>

      <!--BTN XS-->
      <v-row
        v-if="userHistory && $vuetify.display.xs"
        align-center
        justify-center
        class="justify-center text-center"
        row
      >
        <v-btn depressed color="black" dark @click="loadCharts">
          {{ $t("home.get_activity") }}
        </v-btn>
      </v-row>

      <!--CHARTS-->
      <charts v-if="userHistory" ref="charts" />
    </div>

    <!----------------------------------ADMIN APPROVAL SUMMARY------------------------------------->
    <admin-history-summary
      v-if="
        $store.getters.role === 'LekoAdmin' ||
        $store.getters.role === 'SuperAdmin'
      "
    />

    <admin-user-monthly-summary
      v-if="
        // $store.getters.role === 'LekoAdmin' ||
        $store.getters.role === 'SuperAdmin'
      "
    />

    <admin-inventory-intake
      v-if="
        // $store.getters.role === 'LekoAdmin' ||
        $store.getters.role === 'SuperAdmin'
      "
    />

    <!----------------------------------------DATA EXPORTS----------------------------------------->
    <div
      v-if="canAccessDataExports"
      class="pb-8"
    >
      <v-toolbar color="grey-darken-4" flat dark dense>
        <v-toolbar-title @click="showDataExports = !showDataExports">
          {{ $t("home.data_exports.title") }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn text icon @click="showDataExports = !showDataExports">
          <v-icon v-if="showDataExports"> mdi-chevron-up </v-icon>
          <v-icon v-else> mdi-chevron-down </v-icon>
        </v-btn>
      </v-toolbar>
      <v-card v-if="showDataExports" flat class="ma-2 pa-4">
        <v-row align="start">
          <v-col cols="12" md="5">
            <v-autocomplete
              v-model="exportInstitution"
              :items="institutions"
              :label="$t('home.data_exports.select_institution')"
              :hint="$t('home.select_institution')"
              :loading="loadingInstitutions"
              variant="solo"
              item-title="title"
              item-value="_id"
              persistent-hint
              color="red-darken-2"
              clearable
            />
          </v-col>
        </v-row>
        <v-row align="start">
          <v-col cols="12" sm="6" md="4" class="d-flex flex-column">
            <v-btn
              block
              color="red-darken-3"
              variant="flat"
              :loading="loadingTemporaryExport"
              :disabled="!canRunDataExport || exportBusy"
              @click="exportTemporaryParts"
            >
              {{ $t("home.data_exports.temporary_parts") }}
              <v-icon end>mdi-email-outline</v-icon>
            </v-btn>
            <div class="text-caption text-medium-emphasis mt-1">
              {{ $t("home.data_exports.temporary_parts_hint") }}
            </div>
          </v-col>
          <v-col cols="12" sm="6" md="4" class="d-flex flex-column">
            <v-btn
              block
              color="red-darken-3"
              variant="flat"
              :loading="loadingHistoryExport"
              :disabled="!canRunDataExport || exportBusy"
              @click="exportHistoryTimeline"
            >
              {{ $t("home.data_exports.history") }}
              <v-icon end>mdi-email-outline</v-icon>
            </v-btn>
            <div class="text-caption text-medium-emphasis mt-1">
              {{ $t("home.data_exports.history_hint") }}
            </div>
          </v-col>
          <v-col cols="12" sm="6" md="4" class="d-flex flex-column">
            <v-btn
              block
              color="red-darken-3"
              variant="flat"
              :loading="loadingInventoryExport"
              :disabled="!canRunDataExport || exportBusy"
              @click="exportInventory"
            >
              {{ $t("home.data_exports.inventory") }}
              <v-icon end>mdi-email-outline</v-icon>
            </v-btn>
            <div class="text-caption text-medium-emphasis mt-1">
              {{ $t("home.data_exports.inventory_hint") }}
            </div>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-btn
              block
              color="red-darken-3"
              variant="flat"
              :loading="loadingSalesExport"
              :disabled="!canRunDataExport || exportBusy"
              @click="exportSales"
            >
              {{ $t("home.data_exports.sales") }}
              <v-icon end>mdi-email-outline</v-icon>
            </v-btn>
            <div class="text-caption text-medium-emphasis mt-1">
              {{ $t("home.data_exports.sales_hint") }}
            </div>
          </v-col>
        </v-row>
      </v-card>
    </div>

    <!-------------------------------------DELETE INSTITUTION-------------------------------------->
    <div
      v-if="
        $store.getters.role === 'LekoAdmin' ||
        $store.getters.role === 'SuperAdmin'
      "
      class="pb-8"
    >
      <!--TOOLBAR-->
      <v-toolbar color="grey-darken-4" flat dark dense>
        <v-toolbar-title
          
          @click="dInstitution = !dInstitution"
        >
          {{ $t("home.delete_institution") }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn text icon @click="dInstitution = !dInstitution">
          <v-icon v-if="dInstitution"> mdi-chevron-up </v-icon>
          <v-icon v-else> mdi-chevron-down </v-icon>
        </v-btn>
      </v-toolbar>
      <!--CONTENT-->
      <v-card v-if="dInstitution" flat class="ma-2 pt-4">
        <v-row>
          <v-col cols="12" xs="12" md="12" lg="12" class="pa-2">
            <v-alert
              v-model="alert.value"
              :type="alert.type"
              variant="tonal"
              border="bottom"
            >
              {{ alert.message }}
            </v-alert>
          </v-col>
          <v-row class="pa-5">
            <v-col cols="12" xs="12" md="4" class="pa-1 pl-3">
              <v-autocomplete
                v-model="selectedInstitution"
                :items="institutions"
                :label="$t('home.institution_title')"
                :hint="$t('home.select_institution')"
                :loading="loadingInstitutions"
                variant="solo"
                item-title="title"
                item-value="_id"
                persistent-hint
                color="red-darken-2"
              />
            </v-col>

            <v-col cols="12" xs="12" md="4" class="pa-1">
              <v-text-field
                id="password"
                v-model="password"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showPassword ? 'text' : 'password'"
                label="Password"
                prepend-inner-icon="mdi-lock"
                color="red-darken-2"
                @click:append="showPassword = !showPassword"
              />
            </v-col>

            <v-col cols="12" xs="12" md="2" class="pa-1 pl-4 pt-3">
              <v-btn
                color="red-darken-4"
                dark
                :loading="loadingDelete"
                @click="deleteInstitution"
              >
                {{ $t("home.delete") }}
                <v-icon end> mdi-delete-outline </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-row>
      </v-card>
    </div>

    <search-dialog ref="searchDialog" />
    <generalAlert ref="generalAlert" />
    <v-snackbar v-model="snackbar.value" color="orange">
      {{ snackbar.text }}
      <v-btn text dark @click="snackbar.value = false"> Close </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import Toolbar from "@/components/Home/toolbar.vue";
import Charts from "@/components/Home/charts.vue";
import AdminHistorySummary from "@/components/Home/adminHistorySummary.vue";
import AdminUserMonthlySummary from "@/components/Home/adminUserMonthlySummary.vue";
import AdminInventoryIntake from "@/components/Home/adminInventoryIntake.vue";
import Stats from "@/components/Home/stats.vue";
import generalAlert from "@/components/generalAlert.vue";
import SearchDialog from "@/components/Home/searchDialog.vue";
import MaintenanceBanner from "@/components/MaintenanceBanner.vue";
import getRequest from "../api/getRequest";
import putRequest from "../api/putRequest";
import { useDisplay } from "vuetify";

export default {
  components: {
    MaintenanceBanner,
    charts: Charts,
    AdminHistorySummary,
    AdminUserMonthlySummary,
    AdminInventoryIntake,
    toolbar: Toolbar,
    stats: Stats,
    searchDialog: SearchDialog,
    generalAlert,
  },
  data: () => ({
    loading: false,
    userHistory: true,
    userRoles: [
      { title: "Leko Digitalization Employee", value: "LekoEmployee" },
      { title: "Autodemolition Admin", value: "InstitutionAdmin" },
      { title: "Autodemolition Manager", value: "InstitutionManager" },
      { title: "Operator", value: "User" },
      { title: "Ebay Operator", value: "EbayOperator" },
      { title: "LEKO Administrator", value: "LekoAdmin" },
      { title: "SuperAdmin", value: "SuperAdmin" },
    ],
    selectedUserRole: "",
    users: [],
    selectedUser: null,
    statusOptions: [
      {
        value: "1.0",
        titleKey: "part_status.inserted_temporary_parts",
        allowedRoles: [
          "SuperAdmin",
          "LekoAdmin",
          "LekoEmployee",
          "InstitutionAdmin",
          "InstitutionManager",
        ],
      },
      {
        value: "1.1",
        titleKey: "part_status.parts_sent_for_approval",
        allowedRoles: [
          "SuperAdmin",
          "LekoAdmin",
          "LekoEmployee",
          "InstitutionAdmin",
          "InstitutionManager",
        ],
      },
      {
        value: "1.2",
        titleKey: "part_status.parts_sent_for_review",
        allowedRoles: ["SuperAdmin", "LekoAdmin", "LekoEmployee"],
      },
      {
        value: "1.3",
        titleKey: "part_status.refused_parts",
        allowedRoles: ["SuperAdmin", "LekoAdmin", "LekoEmployee"],
      },
      {
        value: "1.4",
        titleKey: "part_status.approved_parts",
        allowedRoles: ["SuperAdmin", "LekoAdmin", "LekoEmployee"],
      },
      {
        value: "2.0",
        titleKey: "part_status.inserted_inventory",
        allowedRoles: [
          "SuperAdmin",
          "LekoAdmin",
          "LekoEmployee",
          "InstitutionAdmin",
          "InstitutionManager",
        ],
      },
      // Admin-only status (example of role-based differences)
      {
        value: "1.6",
        titleKey: "part_status.saved_approve_parts",
        allowedRoles: ["SuperAdmin", "LekoAdmin", "LekoEmployee"],
      },
      {
        value: "6.0",
        titleKey: "part_status.sold",
        allowedRoles: [
          "SuperAdmin",
          "LekoAdmin",
          "LekoEmployee",
          "InstitutionAdmin",
          "InstitutionManager",
        ],
      },
    ],
    selectedItems: [],
    statusString: "",
    selectedInstitution: null,
    institutions: [],
    loadingInstitutions: false,
    password: null,
    showPassword: false,
    loadingDelete: false,
    alert: {
      value: false,
      type: "success",
      message: "",
    },
    dInstitution: false,
    showDataExports: true,
    exportInstitution: null,
    loadingTemporaryExport: false,
    loadingHistoryExport: false,
    loadingInventoryExport: false,
    loadingSalesExport: false,
    snackbar: {
      value: false,
      text: "",
    },
  }),
  computed: {
    canAccessDataExports() {
      return (
        // this.$store.getters.role === "LekoAdmin" ||
        this.$store.getters.role === "SuperAdmin"
      );
    },
    exportEmail() {
      const userEmail = this.$store.getters.userEmail;
      if (userEmail && userEmail.length > 1) return userEmail;
      return "";
    },
    canRunDataExport() {
      return Boolean(this.exportEmail && this.exportInstitution);
    },
    exportBusy() {
      return (
        this.loadingTemporaryExport
        || this.loadingHistoryExport
        || this.loadingInventoryExport
        || this.loadingSalesExport
      );
    },
    availableStatusItems() {
      const role = this.$store.getters.role;
      return this.statusOptions
        .filter((s) => (s.allowedRoles || []).includes(role))
        .map((s) => ({ value: s.value, title: this.$t(s.titleKey) }));
    },
    shouldWrapStatuses() {
      const role = this.$store.getters.role;
      return role === "SuperAdmin" || this.availableStatusItems.length > 7;
    },
    filteredUserRoles() {
      // Get the logged-in user's role
      const currentRole = this.$store.getters.role;
      // Only include `SuperAdmin` if the logged-in user is a `SuperAdmin`
      return this.userRoles.filter(
        (role) => role.value !== "SuperAdmin" || currentRole === "SuperAdmin",
      );
    },
    display() {
      return useDisplay();
    },
  },
  watch: {
    selectedItems(value) {
      let str = "";
      value.forEach((element) => {
        str += `${element},`;
      });
      this.statusString = str;
    },
    selectedUserRole(value) {
      // Clear selection immediately to avoid showing raw id
      // when the current selectedUser doesn't exist in the new role's users list yet.
      this.selectedUser = null;
      this.users = [];
      this.getUsersByRole(value);
    },
    selectedUser(value) {
      if (value !== null && this.selectedItems.length > 0) {
        this.loadCharts();
      }
    },
  },
  mounted() {
    this.getLocale();
    this.getInstitutions();
    if (this.$store.getters.hasUnpaidInvoices) {
      this.$nextTick(() => {
        if (this.$refs.generalAlert) {
          this.$refs.generalAlert.open({
            title: this.$t("unpaid_invoice_alert_title"),
            message: this.$t("unpaid_invoice_alert_message"),
            type: "info",
          });
        }
      });
    }
  },
  created() {
    const currentUsersRole = this.$store.getters.role;
    this.selectedUserRole = currentUsersRole;
    this.selectedUser = this.$store.getters.userId;
    // If logged in user's role is admin he can see all kind of roles.
    if (currentUsersRole === "InstitutionAdmin") {
      // Owner
      this.userRoles = this.userRoles.filter(
        (obj) =>
          obj.value !== "LekoAdmin" &&
          obj.value !== "LekoEmployee" &&
          obj.value !== "SuperAdmin",
      );
    } else if (currentUsersRole === "LekoEmployee") {
      // LekoEmployee
      this.userRoles = this.userRoles.filter(
        (obj) => obj.value !== "LekoAdmin" && obj.value !== "SuperAdmin",
      );
    } else if (currentUsersRole === "InstitutionManager") {
      // Manager
      this.userRoles = this.userRoles.filter(
        (obj) =>
          obj.value !== "LekoAdmin" &&
          obj.value !== "InstitutionAdmin" &&
          obj.value !== "LekoEmployee" &&
          obj.value !== "SuperAdmin",
      );
    } else if (
      currentUsersRole === "User" ||
      this.$store.getters.role === "EbayOperator"
    ) {
      // Worker
      this.userRoles = this.userRoles.filter(
        (obj) =>
          obj.value !== "LekoAdmin" &&
          obj.value !== "InstitutionAdmin" &&
          obj.value !== "InstitutionManager" &&
          obj.value !== "LekoEmployee" &&
          obj.value !== "SuperAdmin" &&
          // Keep only the logged-in worker-type role
          (currentUsersRole === "User"
            ? obj.value !== "EbayOperator"
            : obj.value !== "User"),
      );
    }
  },
  methods: {
    toggleStatus(value) {
      if (this.selectedItems.includes(value)) {
        this.selectedItems = this.selectedItems.filter((v) => v !== value);
        return;
      }
      this.selectedItems = [...this.selectedItems, value];
    },
    getLocale() {
      this.userRoles = this.userRoles.map((role) => {
        switch (role.value) {
          case "LekoEmployee":
            return {
              ...role,
              title: this.$t("users.table.leko_digitalization_employee"),
            };
          case "InstitutionAdmin":
            return { ...role, title: this.$t("users.table.institution_admin") };
          case "InstitutionManager":
            return {
              ...role,
              title: this.$t("users.table.institution_manager"),
            };
          case "User":
            return { ...role, title: this.$t("users.table.operator") };
          case "EbayOperator":
            return { ...role, title: this.$t("users.table.ebay_operator") };
          case "LekoAdmin":
            return { ...role, title: this.$t("roles.leko_admin") };
          case "SuperAdmin":
            return { ...role, title: this.$t("roles.super_admin") };
          default:
            return role;
        }
      });
    },
    loadCharts() {
      const { charts } = this.$refs;
      if (this.selectedUser !== null && this.selectedItems.length < 1) {
        /**
         * THROWS ERROR
         */
      } else {
        charts.loadCharts(
          this.statusString,
          this.selectedUser === null
            ? this.$store.getters.userId
            : this.selectedUser,
        );
      }
    },
    getUsersByRole(role) {
      this.loading = true;
      getRequest(
        "/user/",
        `role=${this.$store.getters.role}&query_role=${role}&institution_id=${this.$store.getters.institutionId}`,
      )
        .then((response) => {
          this.users = response.users;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getInstitutions() {
      this.loadingInstitutions = true;
      getRequest("/institution/")
        .then((response) => {
          this.institutions = response.institutions;
          this.loadingInstitutions = false;
        })
        .catch(() => {
          this.loadingInstitutions = false;
        });
    },
    deleteInstitution() {
      this.loadingDelete = true;
      putRequest(
        "/institution/thorough-delete",
        `id=${this.selectedInstitution}`,
        { password: this.password },
      )
        .then((result) => {
          this.alert = {
            value: true,
            type: "success",
            message: result.data,
          };
        })
        .catch((error) => {
          this.alert = {
            value: true,
            type: "error",
            message: error,
          };
        })
        .finally(() => {
          this.loadingDelete = false;
          setTimeout(() => {
            this.alert.value = false;
          }, 2000);
        });
    },
    openSearchDialog() {
      const { searchDialog } = this.$refs;
      searchDialog.open();
    },
    showExportResult(success, successKey) {
      this.snackbar = {
        value: true,
        text: success
          ? this.$t(successKey)
          : this.$t("home.data_exports.fail"),
      };
    },
    async exportTemporaryParts() {
      if (!this.canRunDataExport) return;

      this.loadingTemporaryExport = true;
      try {
        const query = `institution_id=${this.exportInstitution}&role=${
          this.$store.getters.role
        }`;
        await getRequest("/temporary-part/insert/export", query);
        this.showExportResult(true, "home.data_exports.temporary_success");
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Failed to start temporary parts export", error);
        this.showExportResult(false);
      } finally {
        this.loadingTemporaryExport = false;
      }
    },
    async exportHistoryTimeline() {
      if (!this.canRunDataExport) return;

      this.loadingHistoryExport = true;
      try {
        const query = `institution_id=${this.exportInstitution}&role=${
          this.$store.getters.role
        }`;
        await getRequest("/history/export", query);
        this.showExportResult(true, "home.data_exports.history_success");
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Failed to start history export", error);
        this.showExportResult(false);
      } finally {
        this.loadingHistoryExport = false;
      }
    },
    async exportInventory() {
      if (!this.canRunDataExport) return;

      this.loadingInventoryExport = true;
      try {
        const query = `institution_id=${this.exportInstitution}&role=${
          this.$store.getters.role
        }`;
        await getRequest("/part/inventory/excel-export", query);
        this.showExportResult(true, "home.data_exports.inventory_success");
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Failed to start inventory export", error);
        this.showExportResult(false);
      } finally {
        this.loadingInventoryExport = false;
      }
    },
    async exportSales() {
      if (!this.canRunDataExport) return;

      this.loadingSalesExport = true;
      try {
        const query = `institution_id=${this.exportInstitution}&role=${
          this.$store.getters.role
        }`;
        await getRequest("/sale/excel-export", query);
        this.showExportResult(true, "home.data_exports.sales_success");
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Failed to start sales export", error);
        this.showExportResult(false);
      } finally {
        this.loadingSalesExport = false;
      }
    },
  },
};
</script>

<style scoped>
.statusBar {
  display: block;
  align-items: center;
  min-width: 0; /* allows inner scroller */
  gap: 12px;
}

.statusBarLabel {
  white-space: nowrap;
  font-size: 12px;
  opacity: 0.85;
}

.statusBarItems {
  display: flex;
  align-items: center;
  gap: 0px;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  padding-bottom: 2px; /* nicer scrollbar spacing */
  min-width: 0;
  flex: 1 1 auto;
}

.statusBarItemsWrap {
  flex-wrap: wrap;
  white-space: normal;
  row-gap: 0px;
  column-gap: 10px;
  overflow-x: hidden; /* no horizontal scroll when wrapping */
  padding-bottom: 0;
}

.statusBarItem {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  user-select: none;
}

.statusBarItem:focus-visible {
  outline: 2px solid rgba(255, 255, 255, 0.35);
  outline-offset: 3px;
  border-radius: 6px;
}

.statusBarCheckbox {
  margin: 0;
}

.statusBarText {
  font-size: 12px;
  line-height: 1.1;
}
</style>
